module.exports = __webpack_public_path__ + "static/media/fh_3l.ea0c7d03.png";